import { render } from "./dispatched.vue?vue&type=template&id=7d9f0695&scoped=true"
import script from "./dispatched.vue?vue&type=script&lang=js"
export * from "./dispatched.vue?vue&type=script&lang=js"

import "./dispatched.vue?vue&type=style&index=0&id=7d9f0695&scoped=true&lang=css"

import exportComponent from "D:\\Kaung\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d9f0695"]])

export default __exports__